// extracted by mini-css-extract-plugin
module.exports = {"style":"_2uJDkrIqurwF9AZtpjwKC9"};